<template>
  <div class="editWorksheet" id="editWorksheet">
    <van-cell-group class="forestInput">
      <van-field
        :label="$t('workOrder.workOrderHeader') + '：'"
        v-model="baseData.department"
        :placeholder="$t('workOrder.workOrderHeaderTip')"
        clearable
        required
      />
    </van-cell-group>
    <van-cell-group class="forestInput">
      <van-field
        :label="$t('workOrder.workOrderNum') + '：'"
        v-model="baseData.number"
        :placeholder="$t('workOrder.workOrderNumTip')"
        clearable
        required
      />
    </van-cell-group>
    <van-cell-group class="forestInput">
      <van-field
        :label="$t('workOrder.workOrderType') + '：'"
        v-model="typeName"
        :placeholder="$t('workOrder.workOrderTypeTip')"
        readonly
        required
        right-icon="arrow"
        @click="checkworkerTypePicker"
      />
    </van-cell-group>
    <!-- 添加接收 -->
    <van-cell-group class="role forestInput">
      <van-field
        v-model="roleValueList"
        required
        type="textarea"
        :label="$t('workOrder.receiver') + '：'"
        :placeholder="$t('workOrder.receiverTip')"
        @click="checkRolePicker"
        right-icon="arrow"
        readonly
        rows="1"
        autosize
      />
    </van-cell-group>
    <p class="fgx"></p>
    <van-cell-group class="forestInput">
      <van-field
        :label="$t('workOrder.articleTitle') + '：'"
        :placeholder="$t('workOrder.articleTitleTip')"
        v-model="baseData.title"
        clearable
        required
      />
    </van-cell-group>
    <!-- 富文本编辑 -->
    <van-cell-group required class="historyMain ggMainEditor">
      <van-field required :label="$t('common.content') + '：'" readonly />
      <div class="richText">
        <p
          class="historyDetail ggMainDetail"
          v-html="baseData.content"
          @click="getRichText()"
        ></p>
        <span class="contentPlaceholder">{{ contentPlaceholder }}</span>
      </div>
    </van-cell-group>
    <!-- 上传附件 -->
    <div class="uploadingFiles">
      <h4>{{ $t("common.affixTit") }}</h4>
      <a href="javascript:void(0);" @click="uploadFile">{{
        $t("common.upAffixTit")
      }}</a>
      <div class="listItem" v-if="baseData.baseFiles.length > 0">
        <van-cell
          v-for="(item, index) in baseData.baseFiles"
          :key="index"
          class="item"
        >
          <dl class="fl">
            <dt>
              <img
                :src="
                  getFormat(item.fileName) == 'jpg' ||
                  getFormat(item.fileName) == 'png' ||
                  getFormat(item.fileName) == 'jpeg'
                    ? item.url
                    : getFormat(item.fileName) == 'pdf'
                    ? '' + baseUrl + 'searchImg/pdf.png'
                    : getFormat(item.fileName) == 'xlsx' ||
                      getFormat(item.fileName) == 'xls'
                    ? '' + baseUrl + 'searchImg/excel.png'
                    : '' + baseUrl + 'searchImg/word.png'
                "
                alt
              />
            </dt>
            <dd class="dtName">{{ item.fileName }}</dd>
            <dd class="Mb">
              <span>{{ getMb(item.fileSize) }}</span>
            </dd>
          </dl>
          <a
            href="javascript:void(0);"
            class="deleteBtn fr"
            @click="setDelete(index)"
          >
            <van-icon name="delete" />
          </a>
        </van-cell>
      </div>
    </div>
    <!-- 弹出层 富文本编辑 -->
    <van-popup
      v-model="showRichTextPicker"
      position="bottom"
      class="clssifyPicker"
    >
      <add-text
        :textSource="RichTextData"
        @getData="changeMain"
        :propsImgs="textImgs"
        :selecRightType="selecRightType"
        :selecLeftType="selecLeftType"
      ></add-text>
    </van-popup>
    <!-- 弹出层：选择工作单类型 -->
    <van-popup v-model="workerTypePicker" position="bottom">
      <van-picker
        show-toolbar
        :title="$t('workOrder.workOrderType')"
        :columns="workerTypeList"
        value-key="name"
        @cancel="workerTypePicker = false"
        @confirm="onworkerTypeConfirm"
      />
    </van-popup>
    <!-- 弹出层：角色管理 -->
    <van-popup v-model="showRolePicker" position="bottom" class="roleBox">
      <select-staff
        :staffData="staffData"
        @getRoleData="changeRoleData"
        :selecRightType="selecRightType"
        :selecLeftType="selecLeftType"
      ></select-staff>
    </van-popup>
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
import { getDictList } from "@/utils/common";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
import { mapState } from "vuex";
const addText = () => import("@/components/common/addText");
const selectStaff = () => import("@/views/worksheet/compontents/selectStaff");
// const selectStaff = () => import("@/components/common/selectStaff");

export default {
  name: "editWorksheet",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      gzdName: "",
      baseData: {
        department: "",
        title: "",
        content: "",
        type: "", //工作单类型
        recipients: [], //接收人，数组
        number: "", //文号
        baseFiles: [], //数组列表
      },
      contentPlaceholder: this.$t("workOrder.sendContent"),
      RichTextData: {},
      showRichTextPicker: false,
      textImgs: {}, //传递子组件图片
      addType: true,
      selecRightType: "", //更改App右上角值
      selecLeftType: "", //更改App左上角值
      workerTypePicker: false, //工作类型
      workerTypeList: [], //工作类型列表
      typeName: "",
      showRolePicker: false, //角色选择层
      staffData: {}, //传递的人员的对象
      roleValueList: "", //选中的角色
      clientType: "",
    };
  },
  components: {
    addText,
    selectStaff,
  },
  mounted() {
    document.title = "创建工作单";
    window.setFile = this.setFiles; //app返回图片回调
    window.onRightClicked = this.addInform; //保存/新增通知
    window.onLeftClicked = this.cancelText; //取消富文本编辑
    this.clientType = getDeviceType();
    this.$nextTick(() => {
      this.getworkerTypeList();
      this.initAndroid();
      this.initPage();
    });
  },
  methods: {
    initPage() {
      if (this.userinfo) {
        // this.getRole(this.userinfo.uid);
      }
    },
    initAndroid() {
      if (this.clientType == "android") {
        window.android.getInfo(111, this.$t("common.send"));
      }
    },

    //富文本编辑
    getRichText() {
      let _this = this;
      _this.RichTextData.count = _this.baseData.content;
      _this.showRichTextPicker = true;
      if (this.clientType == "android") {
        window.android.getInfo(111, _this.$t("common.save"));
        window.android.getInfo(112, _this.$t("common.cancel"));
      } else {
        //IOS
        window.webkit.messageHandlers.closeNavigation.postMessage("1");
      }
    },
    //富文本编辑回调
    changeMain(data) {
      let _this = this;
      _this.showRichTextPicker = false;
      if (this.clientType == "android") {
        window.android.getInfo(111, _this.$t("common.send"));
        window.android.getInfo(112, "");
      } else {
        //IOS
        window.webkit.messageHandlers.closeNavigation.postMessage("2");
      }
      if (data.count != "") {
        _this.contentPlaceholder = "";
      }
      _this.baseData.content = data.count;
      _this.selecRightType = "";
      _this.selecLeftType = "";
    },
    uploadFile() {
      //点击添加附件
      let _this = this;
      if (_this.clientType == "android") {
        window.android.getInfo(101);
      } else {
        window.webkit.messageHandlers.getImgs.postMessage("2");
      }
    },
    setFiles(data) {
      //App回调添加上传文件
      let arr = [];
      if (this.clientType == "IOS") {
        let cc = JSON.parse(data);
        if (cc.code == "101") {
          arr.push(cc);
          this.baseData.baseFiles = this.baseData.baseFiles.concat(arr);
        } else {
          this.textImgs = data;
        }
      } else {
        if (data.code == "101") {
          arr.push(data);
          this.baseData.baseFiles = this.baseData.baseFiles.concat(arr);
        } else {
          this.textImgs = data;
        }
      }
    },
    getMb(Kb) {
      let size = "";
      size = (Kb / 1024).toFixed(2) + "Kb";
      return size;
    },
    setDelete(index) {
      //删除上传的文件
      this.baseData.baseFiles.splice(index, 1);
    },
    getFormat(name) {
      //获取文件后缀
      const _index = name.lastIndexOf(".");
      return _index >= 0 ? name.substring(_index + 1, name.length) : "";
    },

    //获取工作类型列表
    async getworkerTypeList() {
      this.workerTypeList = await getDictList("GZDLX");
    },
    //选择工作单类型
    onworkerTypeConfirm(data) {
      console.log(data);
      this.typeName = data.name;
      this.baseData.type = data.code;
      this.workerTypePicker = false;
    },
    //工作类型
    checkworkerTypePicker() {
      this.workerTypePicker = true;
    },

    checkRolePicker() {
      //人员选择
      let _this = this;
      _this.staffData = _this.baseData;
      _this.showRolePicker = true;
      if (this.clientType == "android") {
        window.android.getInfo(111, _this.$t("common.ok"));
        window.android.getInfo(112, _this.$t("common.cancel"));
      } else {
        //IOS
        window.webkit.messageHandlers.closeNavigation.postMessage("1");
      }
    },
    changeRoleData(data) {
      let _this = this;
      // this.roledata = JSON.parse(sessionStorage.getItem("sessionarr")) || [];
      console.log("data====" + JSON.stringify(data));
      _this.roleValueList = data.count;
      if (data.ids) {
        _this.baseData.recipients = data.ids;
      }
      _this.showRolePicker = false;
      if (_this.clientType == "android") {
        window.android.getInfo(111, _this.$t("common.send"));
        window.android.getInfo(112, "");
      } else {
        //IOS
        window.webkit.messageHandlers.closeNavigation.postMessage("2");
      }
      _this.selecRightType = "";
      _this.selecLeftType = "";
    },
    addInform(changeType) {
      let _this = this;
      // let mode = "add";
      console.log("changeType====" + changeType);
      _this.selecRightType = changeType;
      if (changeType == _this.$t("common.send") || _this.clientType == "IOS") {
        //编辑保存/新增通知
        if (_this.addType) {
          _this.addType = false;
          if (
            _this.baseData.title == "" ||
            _this.baseData.content == _this.$t("workOrder.sendContent") ||
            _this.baseData.content == "" ||
            _this.baseData.recipients.length < 1 ||
            _this.baseData.type == "" ||
            _this.baseData.number == "" ||
            _this.baseData.department == ""
          ) {
            _this.addType = true;
            _this.$toast(_this.$t("common.ggToastTip"));
            return;
          }

          let data = {
            baseFiles:
              _this.baseData.baseFiles.length > 0
                ? _this.baseData.baseFiles
                : null,
            department: _this.baseData.department,
            content: _this.baseData.content,
            title: _this.baseData.title,
            recipients: _this.baseData.recipients,
            number: _this.baseData.number,
            type: _this.baseData.type,
          };

          _this.$api.worker
            .saveWorkOrder(data)
            .then((res) => {
              if (res.code == "1") {
                _this.$toast(_this.$t("common.issueTip"));
                setTimeout(function () {
                  //将当前页面关闭
                  if (_this.clientType == "android") {
                    //安卓
                    window.android.getInfo(106, "2");
                  } else {
                    //IOS
                    window.webkit.messageHandlers.closePage.postMessage("2");
                  }
                }, 3000);
              } else {
                this.addType = true;
                _this.$toast(res.msg);
              }
            })
            .catch((err) => {
              this.addType = true;
              console.log(err);
            });
        } else {
          this.$toast(_this.$t("common.moreClickToastMsg"));
        }
      }
    },

    cancelText(changeLeftType) {
      this.selecLeftType = changeLeftType;
    },
  },
  computed: {
    ...mapState(["userinfo"]),
  },
  watch: {
    userinfo: {
      handler: function () {
        this.initPage();
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.editWorksheet {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  padding-top: 10px;
  position: relative;
  > p {
    width: 100%;
    height: 15px;
    background-color: #f6f6f6;
  }
  /**多选后的颜色 */
  .van-checkbox__icon--checked .van-icon {
    background-color: #07c160;
    border-color: #07c160;
  }
  .forestInput {
    .van-cell {
      .van-field__label {
        span {
          color: #666;
          font-size: 16px;
        }
      }
      .van-cell__value {
        .van-field__control {
          color: #333;
          font-size: 14px;
          text-align: right;
        }
      }
      .van-cell__title {
        width: 120px;
      }
    }
    .van-cell.lbStyle {
      .van-cell__title {
        width: 150px;
      }
    }
  }
  //富文本及图片上传
  .ggMainEditor {
    width: 100%;
    padding: 10px 0;
    .van-cell {
      .van-field__label {
        span {
          color: #666;
          font-size: 16px;
        }
      }
      .van-cell__title {
        width: 200px;
      }
    }
    .van-cell:not(:last-child)::after {
      display: none;
    }
    .richText {
      padding: 0 16px;
      position: relative;
      .ggMainDetail {
        width: 100%;
        height: 260px;
        padding: 5px 5px;
        overflow-y: scroll;
        border: 1px solid #f6f6f6;
        color: #333;
        font-size: 12px;

        img {
          max-width: 100% !important;
          margin: 0 auto;
          display: block;
        }
      }
      .contentPlaceholder {
        color: #999;
        font-size: 14px;
        position: absolute;
        top: 10px;
        left: 25px;
      }
    }
  }
  .historyMain.ggMainEditor {
    .van-cell {
      padding: 0 16px;
      .van-cell__title {
        width: 200px;
      }
      .van-field__control {
        color: #333;
        font-size: 14px;
        text-align: right;
      }
    }
  }
  .uploadingFiles {
    width: 100%;
    padding: 15px 16px;
    background-color: #fff;
    margin-top: 10px;
    position: relative;
    margin-bottom: 45px;
    h4 {
      font-weight: 400;
      font-size: 16px;
      color: #666;
    }
    > a {
      font-size: 14px;
      position: absolute;
      right: 16px;
      top: 15px;
      color: #08b9fb;
    }
    .listItem {
      .item {
        margin: 10px 0;
        padding: 0;
        border-bottom: 1px solid #f6f6f6;
        min-height: 50px;
        dl {
          width: 85%;
          position: relative;

          dt {
            display: block;
            width: 40px;
            height: 40px;
            background-color: #f6f6f6;
            position: absolute;

            img {
              width: 100%;
              height: 100%;
              border-radius: 5px;
              -webkit-border-radius: 5px;
              -moz-border-radius: 5px;
            }
          }

          dd {
            display: block;
            font-size: 10px;
            color: #999;
            position: absolute;
          }

          dd.dtName {
            font-size: 14px;
            color: #666;
            top: 0px;
            left: 48px;
          }
          dd.Mb {
            top: 17px;
            left: 48px;
          }
          //   dd:nth-child(3) {
          //     top: 15px;
          //     left: 35px;

          //     span {
          //       display: inline-block;
          //       margin-left: 8px;
          //     }
          //   }
        }
        a.deleteBtn {
          margin-right: 12px;
          margin-top: 10px;
          i {
            font-size: 22px;
          }
        }
      }
    }
  }
  .clssifyPicker.van-popup {
    width: 100%;
    height: 100%;
    padding-top: 5px;
  }
  .roleBox.van-popup {
    width: 100%;
    height: 100%;
    padding-top: 5px;

    /**  
    .roleHeader {
      position: relative;
      font-size: 0.42667rem;
      text-align: center;
      color: #333;
      border-bottom: 1px solid #f6f6f6;
      height: 15%;
      padding: 10px 0;

      a:first-child {
        color: rgb(235, 199, 155);
      }
      a {
        height: 100%;
        padding: 0 16px;
        color: #07c160;
        font-size: 0.37333rem;
      }
    }
    .roleMain {
      height: 85%;
      overflow-y: scroll;
    }
    */
  }
}
</style>